import React from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { User } from 'lucide-react';
import "../../../../assets/css/customer/publicCustomerCss/BookingComponent/guestInfo.css";

const GuestInfo = ({ data, errors, handleChange, nextStep }) => {

  const handlePhone = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.startsWith('92')) value = '+' + value;
    else if (!value.startsWith('0')) value = value ? '0' + value : '';
    handleChange({ target: { name: 'guestPhone', value } });
  };

  return (
    <div className="hb-guest-info-wrapper-booking">
      <h2 className="hb-booking-section-title mb-4">
        <User size={24} className="me-2" /> Guest Information
      </h2>

      <Form>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium hb-required-label">Full Name</Form.Label>
              <Form.Control
                type="text"
                name="guestName"
                value={data.guestName}
                isInvalid={!!errors.guestName}
                className="hb-form-control-booking py-2"
                readOnly
              />
              <Form.Control.Feedback type="invalid">{errors.guestName}</Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Email</Form.Label>
              <Form.Control
                type="email"
                name="guestEmail"
                value={data.guestEmail}
                className="hb-form-control-booking py-2"
                readOnly
              />
              <Form.Text className="text-muted">Confirmation will be sent here</Form.Text>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium hb-required-label">Phone Number</Form.Label>
              <Form.Control
                type="tel"
                name="guestPhone"
                value={data.guestPhone}
                onChange={handlePhone}
                placeholder="0300-1234567"
                isInvalid={!!errors.guestPhone}
                className="hb-form-control-booking py-2"
              />
              <Form.Control.Feedback type="invalid">{errors.guestPhone}</Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium hb-required-label">City</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={data.city}
                onChange={handleChange}
                placeholder="Enter your city"
                isInvalid={!!errors.city}
                className="hb-form-control-booking py-2"
              />
              <Form.Control.Feedback type="invalid">{errors.city}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium hb-required-label">Number of Guests</Form.Label>
              <Form.Control
                type="number"
                name="numberOfGuests"
                value={data.numberOfGuests}
                min="1"
                max="10"
                onChange={handleChange}
                isInvalid={!!errors.numberOfGuests}
                className="hb-form-control-booking py-2"
              />
              <Form.Control.Feedback type="invalid">{errors.numberOfGuests}</Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-2">
          <Button onClick={nextStep} className="hb-btn-booking-next px-4 py-2">
            Next <i className="fas fa-arrow-right ms-2"></i>
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default GuestInfo;